import { createContext, useContext, useEffect, useState } from "react";
import { fetchContent, resolveUrl } from "@/lib/api";
import { IMAGES, SERVICES, GALLERY } from "@/data/content";

const SiteContentContext = createContext(null);

const buildResolved = (c) => {
  const overrides = c || {};
  const servicesImages = {};
  SERVICES.forEach((s) => {
    servicesImages[s.id] = overrides.services?.[s.id]
      ? resolveUrl(overrides.services[s.id])
      : s.image;
  });

  const gallery = Array.isArray(overrides.gallery)
    ? overrides.gallery.map((g) => ({ ...g, src: resolveUrl(g.url) }))
    : null;

  return {
    heroImage: overrides.hero ? resolveUrl(overrides.hero) : IMAGES.hero,
    compareBefore: overrides.compareBefore ? resolveUrl(overrides.compareBefore) : IMAGES.compare,
    compareAfter: overrides.compareAfter ? resolveUrl(overrides.compareAfter) : IMAGES.compare,
    servicesImages,
    gallery: gallery && gallery.length ? gallery : GALLERY,
  };
};

export const SiteContentProvider = ({ children }) => {
  const [resolved, setResolved] = useState(() => buildResolved(null));

  useEffect(() => {
    let alive = true;
    fetchContent()
      .then((c) => {
        if (alive) setResolved(buildResolved(c));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <SiteContentContext.Provider value={resolved}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => {
  const ctx = useContext(SiteContentContext);
  return ctx || buildResolved(null);
};
